/* eslint-disable no-extend-native */
/**
 * Polyfill for Array.prototype.at
 * Adds the `at` method to Array prototype if it doesn't exist.
 */
const polyfillArrayAt = () => {
  if (!Array.prototype.at) {
    /**
     * Returns the element at the specified index in an array.
     * If the index is negative, it counts back from the end of the array.
     * If the index is out of bounds, it returns undefined.
     *
     * @param {number} n - The index of the element to return. If negative, it counts from the end.
     * @returns {*} The element at the specified index, or undefined if the index is out of bounds.
     */
    Object.defineProperty(Array.prototype, 'at', {
      value(n) {
        const index = Math.trunc(n) || 0;
        const normalizedIndex = index < 0 ? index + this.length : index;
        return normalizedIndex < 0 || normalizedIndex >= this.length
          ? undefined
          : this[normalizedIndex];
      },
      writable: true,
      configurable: true
    });
  }
};

export default polyfillArrayAt;
